export default "/images/sunrise.svg?8386c5eba76308c5979442ca37a79a6a";